import { render, staticRenderFns } from "./category-main.vue?vue&type=template&id=a9bb050c&scoped=true&"
import script from "./category-main.vue?vue&type=script&lang=js&"
export * from "./category-main.vue?vue&type=script&lang=js&"
import style0 from "./category-main.vue?vue&type=style&index=0&id=a9bb050c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bb050c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VContainer,VImg})
